"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRepos = void 0;
const contentTypes = require("./content-types");
const registry_call_1 = require("./registry-call");
const options_1 = require("./options");
/**
 * Fetches a list of repositories from the container registry.
 *
 * Retrieves the list of repositories available in the registry using the `_catalog` endpoint.
 * Supports pagination to handle registries with large numbers of repositories.
 *
 * OCI Distribution Specification endpoint: `/v2/_catalog`
 *
 * ## Caution
 *
 * The `/v2/_catalog` endpoint is not part of the OCI Distribution Specification.
 * It is supported by most container registries for backward compatibility with Docker Registry V2,
 * but there are no guarantees that newer implementations will support this endpoint.
 *
 * @param registryBase - The base URL of the container registry
 * @param username - Optional username for authentication
 * @param password - Optional password for authentication
 * @param pageSize - Number of repositories to fetch per request (default: 100)
 * @param maxPages - Maximum number of pages to fetch (default: Number.MAX_SAFE_INTEGER)
 * @param options - Optional request configuration options
 * @param observer - Optional observer to record client events
 *
 * @returns Array of repository names available in the registry
 */
async function getRepos(registryBase, username, password, pageSize = 100, maxPages = Number.MAX_SAFE_INTEGER, options = {}, observer) {
    const cloned = (0, options_1.cloneOptions)(options);
    const endpoint = "/_catalog";
    const result = await (0, registry_call_1.paginatedV2Call)(registryBase, contentTypes.JSON, username, password, endpoint, "repositories", pageSize, maxPages, cloned, observer);
    return result;
}
exports.getRepos = getRepos;
//# sourceMappingURL=get-repos.js.map